// Varias queries do schema paginam com PER_PAGE = 6 (query_type.rb) e devolvem
// so a lista, sem total nem hasNextPage. Entao "pagina cheia" e o unico sinal
// de que pode haver mais, e pagina parcial encerra sem gastar requisicao.
export const PER_PAGE = 6;

export const paginaCheia = (lista: readonly unknown[], tamanho: number = PER_PAGE): boolean =>
  lista.length >= tamanho;

// A paginacao por offset pode repetir um item quando algo e criado entre duas
// paginas; sem deduplicar isso vira key duplicada no React e item repetido na
// tela.
export const mesclarPorId = <T extends {id: string}>(anterior: readonly T[], proxima: readonly T[]): T[] => {
  const vistos = new Set(anterior.map((item) => item.id));

  return [...anterior, ...proxima.filter((item) => item.id && !vistos.has(item.id))];
};
